import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import URLSearchParams from '@ungap/url-search-params';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import moment from 'moment-timezone';
import Message from '../Common/Message/Message';
import infoIcon from '../../images/icons/info.svg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ElectronicTicket.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ElectronicTicket extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            tickets: [],
            transaction: {},
            customer: {
                first_name: '',
                last_name: '',
            },
            client: {
                client_name: '',
            },
            flexpasses: [],
            message: {
                title: '',
                content: '',
                type: ''
            },
            ticket_id: -1,
        };
    }
    
    componentDidMount() {
        if (this.props.routeProps.match.params.token) {
            let ticket_id = -1;
            if (this.props.routeProps.match.params.ticketId) {
                ticket_id = this.props.routeProps.match.params.ticketId;
            }
            this.getTransactionTickets(this.props.routeProps.match.params.token, ticket_id);
            this.setState({
                ticket_id,
            });
        }
    }

    getTransactionTickets = (token, ticket_id) => {
        this.setMessage('', '', 'loading');
        const getTickets = async (token, ticket_id) => {
            try {
                const getTransactionTicketsResponse = await getTransactionTickets(token);
                console.log('getTransactionTicketsResponse:', getTransactionTicketsResponse);
                if (getTransactionTicketsResponse.data.tickets || getTransactionTicketsResponse.data.flexpasses) {
                    let tickets = getTransactionTicketsResponse.data.tickets || [];
                    tickets.forEach((ticket) => {
                        ticket.isModalOpen = false;
                        ticket.isDistributed = getTransactionTicketsResponse.data.isDistributed;
                    });
                    if (ticket_id !== -1) {
                        tickets = tickets.filter((ticket) => parseInt(ticket.id, 10) === parseInt(ticket_id, 10));
                    }
                    this.setState({
                        tickets: tickets,
                        transaction: getTransactionTicketsResponse.data.transaction,
                        customer: getTransactionTicketsResponse.data.customer,
                        client: getTransactionTicketsResponse.data.client,
                        flexpasses: getTransactionTicketsResponse.data.flexpasses || [],
                    });
                    this.setMessage('', '', '');
                }

                if (getTransactionTicketsResponse.data.ticket || getTransactionTicketsResponse.data.flexpasses) {
                    let tickets = [];
                    tickets.push(getTransactionTicketsResponse.data.ticket);
                    tickets.forEach((ticket) => {
                        ticket.isModalOpen = false;
                        ticket.isDistributed = getTransactionTicketsResponse.data.isDistributed;
                    });
                    this.setState({
                        tickets: tickets,
                        transaction: getTransactionTicketsResponse.data.transaction,
                        customer: getTransactionTicketsResponse.data.customer,
                        client: getTransactionTicketsResponse.data.client,
                        flexpasses: getTransactionTicketsResponse.data.flexpasses,
                    });
                    this.setMessage('', '', '');
                }
                
                if (getTransactionTicketsResponse.data.error) {
                    this.setMessage('Ooops', getTransactionTicketsResponse.data.error.code, 'error')
                }
                /* else {
                    const getTicketResponse = await getTicket(token);
                    console.log('getTicketResponse:', getTicketResponse);
                    if (getTicketResponse.data.ticket) {
                        let tickets = [];
                        tickets.push(getTicketResponse.data.ticket);
                        tickets.forEach((ticket) => {
                            ticket.isModalOpen = false;
                        })
                        this.setState({
                            tickets: tickets,
                            transaction: getTicketResponse.data.transaction,
                            customer: getTicketResponse.data.customer,
                            client: getTicketResponse.data.client,
                            flexpasses: getTicketResponse.data.flexpasses,
                        });
                        this.setMessage('', '', '');
                    } 
                    if (getTicketResponse.data.error) {
                        this.setMessage('Ooops', getTicketResponse.data.error.code, 'error')
                    }
                } */
            } catch (error) {
                console.log(error);
            }
        }

        async function getTransactionTickets(token) {
            return await ApiRequest(`/electronic-tickets?token=${token}`, {
                method: 'GET',
			});
        }

        /* async function getTicket(transaction_ticket_id) {
            return await ApiRequest(`/transactions/tickets/${transaction_ticket_id}/electronic-ticket`, {
                method: 'GET',
			});
        } */

        getTickets(token, ticket_id);
    }

    /* getElectronicTickets = () => {
        const tickets = this.state.tickets;
        tickets.forEach(async (ticket, ticketIndex) => {
            const getTicketTokenResponse = await getToken(ticket);
            console.log('getTicketTokenResponse:', getTicketTokenResponse);

            if (getTicketTokenResponse.data.token) {
                const getElectronicTicketResponse = await getElectronicTicket(getTicketTokenResponse.data.token);
                console.log('getElectronicTicketResponse:', getElectronicTicketResponse);

                if (getElectronicTicketResponse.data.ticket) {
                    tickets[ticketIndex] = getElectronicTicketResponse.data.ticket;
                    tickets[ticketIndex].isDistributed = getElectronicTicketResponse.data.isDistributed;
                    this.setState({
                        tickets,
                    });
                }

                async function getElectronicTicket(token) {
                    return await ApiRequest(`/electronic-tickets?token=${token}`, {
                        method: 'GET',
                    });
                }
            }

            async function getToken(ticket) {
                return await ApiRequest(`/dev/distribution-token?ticket_id=${ticket.id}`, {
                    method: 'GET',
                });
            }
        });
    } */

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    downloadTicket = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/customer-tickets?token=${this.state.token}`);
    }

    toggleDetails = (index: Number) => {
        let tickets = this.state.tickets;
        tickets[index].isModalOpen = !tickets[index].isModalOpen;
        this.setState({
            tickets,
        });
    }

    renderSeat = (ticket) => {
        if (ticket.event.event_type === 'Video On Demand' || ticket.event.event_type === 'Live Stream' || ticket.event.event_type === 'Scheduled Content') {
            return (
                <React.Fragment>
                    <a className="showtix-button showtix-background__primary-1" href={`/stream/${ticket.activation_code}?event=${ticket.event_id}`} target="_blank">Watch Stream</a>
                </React.Fragment>
            );
        } else {
            if (ticket.venue.venue_type === 'general-admission') {
                return (
                    <React.Fragment>
                        {strings.generalAdmission}{ticket.seat_id}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        {strings.section}{ticket.full_seat_name.split(':')[0]}<br />
                        {strings.row}{ticket.full_seat_name.split(':')[1]} {strings.seat}{ticket.full_seat_name.split(':')[2]}
                    </React.Fragment>
                );
            }
        }
    }

    renderCodePoster = (ticket: Object) => {
        if (ticket.event.event_type === 'Video On Demand' || ticket.event.event_type === 'Live Stream' || ticket.event.event_type === 'Scheduled Content') {
            return (
                <div className="showtix-ticket__poster">
                    <img src={ticket.event.poster_graphic_url ? ticket.event.poster_graphic_url : process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} />
                </div>
            );
        } else {
            if (moment(ticket.event_date.event_datetime_local).format('LL') === moment().format('LL')) {
                return (
                    <div className="showtix-ticket__qr">
                        <img src={ticket.qrcode} />
                    </div>
                );
            } else {
                return (
                    <div className="showtix-ticket__poster">
                        <img src={ticket.event.poster_graphic_url ? ticket.event.poster_graphic_url : process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} />
                    </div>
                );
            }
        }
    }

    renderTickets = () => {
        const responsive = {
            superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 2
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 2
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 1
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1
            }
        };
        if (this.state.tickets.length > 0 || this.state.flexpasses.length > 0) {
            return (
                <Carousel
                    responsive={responsive}
                >
                    {this.state.tickets.map((ticket, index) => (
                        <div>
                            <div className="showtix-ticket">
                                <div className="showtix-ticket__border">
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        {this.renderCheckedIn(ticket)}
                                        {this.renderIsDistributed(ticket)}
                                        <div className="showtix-ticket__customer-ticket">
                                            {index+1} {strings.of} {this.state.tickets.length+this.state.flexpasses.length} 
                                        </div>
                                        {this.renderCodePoster(ticket)}
                                    </div>
                                </div>
                                <div
                                    className={"showtix-ticket__modal " + (ticket.isModalOpen ? ' is-active' : '')}
                                    id={`modal-${index}`}
                                    onClick={() => this.toggleDetails(index)}
                                >
                                    <div
                                        className={"showtix-ticket__modal-content"}
                                    >
                                        {ticket.event.event_type === 'Video On Demand' && (
                                            <div className="showtix-ticket__group">
                                                Streaming link is good for 48 hours from first click.
                                            </div>
                                        )}
                                        <div className="showtix-ticket__group">
                                            <span className="showtix-ticket__label">{strings.client}</span>
                                            {this.state.client.client_name}
                                        </div>
                                        <div className="showtix-ticket__group">
                                            <span className="showtix-ticket__label">{strings.transaction}</span>
                                            {ticket.transaction_id}
                                        </div>
                                        <div className="showtix-ticket__group">
                                            <span className="showtix-ticket__label">{strings.venue}</span>
                                            {ticket.venue.name}<br />
                                            {ticket.venue.address}, {ticket.venue.city}, {ticket.venue.state}, {ticket.venue.zip}<br />
                                            {ticket.venue.phone}
                                        </div>
                                        <div className="showtix-ticket__group">
                                            <span className="showtix-ticket__label">{strings.contact}</span>
                                            {ticket.event.contact_phone}<br />
                                            {ticket.event.contact_email}
                                        </div>
                                    </div>
                                </div>
                                <div className="showtix-ticket__content">
                                    <div className="showtix-ticket__group showtix-ticket__event-name">
                                        {this.renderSeat(ticket)}
                                    </div>
                                    <div className="showtix-ticket__group showtix-ticket__event-name">
                                        {ticket.event.name}
                                    </div>
                                    <div className="showtix-ticket__group showtix-ticket__event-date">
                                        {ticket.event.event_type !== 'Video On Demand' ? (
                                            <React.Fragment>
                                                {moment(ticket.event_date.event_datetime_local.substring(0, 19)).format('LLLL')}
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                Video Available from {moment(ticket.event_date.redeem_start).tz(ticket.venue.timezone).format('LLLL')} to {moment(ticket.event_date.redeem_end).tz(ticket.venue.timezone).format('LLLL')}
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="showtix-ticket__group showtix-ticket__customer-name">
                                                {ticket.hasDistribution ? (
                                                    <React.Fragment>
                                                        <span className="showtix-ticket__label">{strings.patron}</span>
                                                        {ticket.distribution.first_name} {ticket.distribution.last_name} 
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <span className="showtix-ticket__label">{strings.customer}</span>
                                                        {this.state.customer.first_name} {this.state.customer.last_name} 
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="showtix-ticket__group showtix-ticket__customer-price">
                                                <span className="showtix-ticket__label">{strings.price}</span>
                                                {ticket.pricing_option_desc} - {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(ticket.price)}
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        className="showtix-ticket__button"
                                        onClick={() => this.toggleDetails(index)}
                                        aria-label="Toggle Ticket Details modal"
                                        aria-expanded={false}
                                        aria-controls={`modal-${index}`}
                                    >
                                        <img src={infoIcon} alt="" />
                                        {strings.moreInfo}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                    {this.state.flexpasses.map((flexpass, index) => (
                        <div>
                            <div className="showtix-ticket">
                                <div className="showtix-ticket__border">
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                    <span className="showtix-ticket__shape"></span>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="showtix-ticket__customer-ticket">
                                            {this.state.tickets.length+index+1} {strings.of} {this.state.tickets.length+this.state.flexpasses.length} 
                                        </div>
                                        <div className="showtix-ticket__poster">
                                            <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} />
                                        </div>
                                    </div>
                                </div>
                                <div className="showtix-ticket__content">
                                    <div className="showtix-ticket__group showtix-ticket__event-name">
                                        <strong>Your flexpass for {this.state.client.client_name}'s</strong>
                                        {flexpass.name}
                                    </div>
                                    <div className="showtix-ticket__group showtix-ticket__event-description">
                                        When you are ready to purchase your individual tickets, please use the code below during the purchase process. You do not have to redeem all your tickets at once. Some events may be restricted from use with Flex Passes.
                                    </div>
                                   
                                    <div className="showtix-ticket__group showtix-ticket__customer-name">
                                        This Flex Pass is worth {flexpass.max_tickets} ticket(s).<br />
                                        You have redeemed {flexpass.tickets_used} of {flexpass.max_tickets} ticket(s).
                                    </div>
                                    <div className="showtix-ticket__group showtix-ticket__event-date">
                                        Code: {flexpass.code}
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="showtix-ticket__group showtix-ticket__customer-name">
                                                <span className="showtix-ticket__label">{strings.contact}</span>
                                                {flexpass.contact_phone}<br />
                                                {flexpass.contact_email}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="showtix-ticket__group showtix-ticket__customer-price">
                                                <span className="showtix-ticket__label">{strings.price}</span>
                                                {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(flexpass.price)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            )
        } else {
            return (
                <React.Fragment>
                    There's no ticket
                </React.Fragment>
            )
        }
    }

    renderCheckedIn = (ticket) => {
        if (ticket.checked_in_by !== 0) {
            return (
                <div className="showtix-ticket__top">
                    <div className="showtix-badge showtix-background__primary-1">
                        {strings.checkedIn}
                    </div>
                </div>
            );
        }
    }

    renderIsDistributed = (ticket) => {
        if (!ticket.isDistributed) {
            if (ticket.hasDistribution) {
                return (
                    <div className="showtix-ticket__top">
                        <div className="showtix-badge showtix-background__primary-2">
                            {strings.isDistributed}
                        </div>
                    </div>
                );
            }
        } else {
            return null;
        }
        
    }
	
    render() {
		return (
            <React.Fragment>
                <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12">
                            <Message
                                message={this.state.message}
                            />
                            {this.renderTickets()}
                        </div> 
                    </div>
                </div>   
            </React.Fragment>
		);
  	}
}

export default ElectronicTicket;



// WEBPACK FOOTER //
// ./src/components/ElectronicTicket/ElectronicTicket.js